<!--
 * @Author: your name
 * @Date: 2020-06-18 15:06:22
 * @LastEditTime: 2020-06-18 16:53:58
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \leXiangH5线下落地页\src\components\Copyright.vue
--> 
<template>
	<footer id="footer">
        <span>深圳市云智汇科技有限公司</span>
        <span>Copyright © 乐象有品 2020</span>
	</footer>
</template>

<script>

export default {
    name: "Copyright",
};
</script>

<style lang="scss" scoped>
#footer {
    position: absolute;
    bottom: 10px;
    color: rgb(179, 179, 179);
    width: 100%;
    text-align: center;
    span {
        display: block;
        margin-bottom: 4px;
        font-size: 12px;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>